var _ellipse, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyStateExpertise = function SvgEmptyStateExpertise(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.0555,
    cy: 84.0556,
    rx: 82.62,
    ry: 82.6199,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.219 34.6318C40.2118 31.2469 38.9487 27.9565 37.7651 25.1672L37.6324 24.8541C36.6662 22.5728 35.9558 20.8954 34.4943 19.6053C33.274 18.5282 31.5291 17.7283 29.8965 17.4979C27.9404 17.2218 26.0252 17.793 23.3962 18.5771L9.20348 22.7998C6.73397 23.5329 4.92866 24.0688 3.47102 25.3109C2.27015 26.3343 1.22083 27.9211 0.760453 29.4098C0.201995 31.2157 0.425513 32.8826 0.727964 35.1381L0.767232 35.4315C1.19079 38.6052 1.86893 42.3578 2.95723 46.0157C4.04551 49.6734 5.52907 53.1864 6.90939 56.0756L7.03683 56.3426C8.01663 58.3966 8.74075 59.9146 10.1955 61.1215C11.3949 62.1164 13.1409 62.8715 14.7059 63.0719C16.6055 63.3153 18.4101 62.777 20.8787 62.0409L35.0714 57.8182C37.7016 57.0376 39.6175 56.469 41.1046 55.1684C42.3455 54.0831 43.3696 52.4594 43.8025 50.8904C44.321 49.0113 43.999 47.2182 43.5609 44.7799L43.5008 44.4452C42.9672 41.4625 42.226 38.0168 41.219 34.6318ZM12.7105 33.5414C11.6504 33.8568 11.0408 34.9519 11.3489 35.9873C11.657 37.0227 12.7661 37.6065 13.8261 37.291L27.3494 33.2675C28.4095 32.9522 29.0191 31.8571 28.711 30.8216C28.4029 29.7862 27.2938 29.2025 26.2337 29.5179L12.7105 33.5414ZM13.4967 43.2068C13.1885 42.1714 13.7982 41.0763 14.8582 40.7608L28.3815 36.7374C29.4416 36.422 30.5506 37.0057 30.8587 38.0411C31.1668 39.0766 30.5571 40.1716 29.4971 40.4871L15.9738 44.5105C14.9137 44.8259 13.8047 44.2423 13.4967 43.2068ZM17.0056 47.9787C15.9455 48.2941 15.3358 49.3891 15.644 50.4245C15.9521 51.46 17.0612 52.0437 18.1212 51.7282L24.8828 49.7166C25.9429 49.4011 26.5525 48.3061 26.2444 47.2707C25.9364 46.2352 24.8272 45.6515 23.7672 45.9669L17.0056 47.9787Z",
    fill: "#C1C2E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1582_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9545 43.8692C26.9545 40.7866 29.5765 38.2877 32.811 38.2877H135.3C138.535 38.2877 141.157 40.7866 141.157 43.8692V51.6832H26.9545V43.8692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9545 51.6832H141.157V87.7933V123.903C141.157 127.173 138.535 129.823 135.3 129.823H32.811C29.5765 129.823 26.9545 127.173 26.9545 123.903V51.6832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5081 58.25H34.5347C33.4249 58.25 32.5253 59.1153 32.5253 60.1826C32.5253 61.25 33.4249 62.1153 34.5347 62.1153H59.5081C60.6177 62.1153 61.5173 61.25 61.5173 60.1826C61.5173 59.1153 60.6177 58.25 59.5081 58.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.019 66.2566H37.9793C34.9671 66.2566 32.5253 68.6052 32.5253 71.5024C32.5253 74.3995 34.9671 76.7481 37.9793 76.7481H72.9994H108.019C111.031 76.7481 113.473 74.3995 113.473 71.5024C113.473 68.6052 111.031 66.2566 108.019 66.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.287 83.6505H34.5347C33.4249 83.6505 32.5253 84.5159 32.5253 85.583C32.5253 86.6502 33.4249 87.5155 34.5347 87.5155H104.287C105.397 87.5155 106.297 86.6502 106.297 85.583C106.297 84.5159 105.397 83.6505 104.287 83.6505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1008 90.0004H34.5347C33.4249 90.0004 32.5253 90.8657 32.5253 91.9329C32.5253 93.0005 33.4249 93.8659 34.5347 93.8659H64.1008C65.2104 93.8659 66.11 93.0005 66.11 91.9329C66.11 90.8657 65.2104 90.0004 64.1008 90.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9523 96.3507H34.5347C33.4249 96.3507 32.5253 97.2156 32.5253 98.2832C32.5253 99.3504 33.4249 100.216 34.5347 100.216H62.9523C64.0623 100.216 64.962 99.3504 64.962 98.2832C64.962 97.2156 64.0623 96.3507 62.9523 96.3507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.993 108.499H35.3958C33.8105 108.499 32.5253 109.935 32.5253 111.706V121.33C32.5253 123.101 33.8105 124.537 35.3958 124.537H132.993C134.578 124.537 135.863 123.101 135.863 121.33V111.706C135.863 109.935 134.578 108.499 132.993 108.499Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9545 43.8692C26.9545 40.7866 29.5765 38.2877 32.811 38.2877H135.3C138.535 38.2877 141.157 40.7866 141.157 43.8692V51.6832H26.9545V43.8692Z",
    fill: "url(#paint0_linear_1582_533)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9545 51.6832H141.157V87.7933V123.903C141.157 127.173 138.535 129.823 135.3 129.823H32.811C29.5765 129.823 26.9545 127.173 26.9545 123.903V51.6832Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5081 58.25H34.5347C33.4249 58.25 32.5253 59.1153 32.5253 60.1826C32.5253 61.25 33.4249 62.1153 34.5347 62.1153H59.5081C60.6177 62.1153 61.5173 61.25 61.5173 60.1826C61.5173 59.1153 60.6177 58.25 59.5081 58.25Z",
    fill: "url(#paint1_linear_1582_533)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.019 66.2566H37.9793C34.9671 66.2566 32.5253 68.6052 32.5253 71.5024C32.5253 74.3995 34.9671 76.7481 37.9793 76.7481H72.9994H108.019C111.031 76.7481 113.473 74.3995 113.473 71.5024C113.473 68.6052 111.031 66.2566 108.019 66.2566Z",
    fill: "url(#paint2_linear_1582_533)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.287 83.6505H34.5347C33.4249 83.6505 32.5253 84.5159 32.5253 85.583C32.5253 86.6502 33.4249 87.5155 34.5347 87.5155H104.287C105.397 87.5155 106.297 86.6502 106.297 85.583C106.297 84.5159 105.397 83.6505 104.287 83.6505Z",
    fill: "url(#paint3_linear_1582_533)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1008 90.0004H34.5347C33.4249 90.0004 32.5253 90.8657 32.5253 91.9329C32.5253 93.0005 33.4249 93.8659 34.5347 93.8659H64.1008C65.2104 93.8659 66.11 93.0005 66.11 91.9329C66.11 90.8657 65.2104 90.0004 64.1008 90.0004Z",
    fill: "url(#paint4_linear_1582_533)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9523 96.3507H34.5347C33.4249 96.3507 32.5253 97.2156 32.5253 98.2832C32.5253 99.3504 33.4249 100.216 34.5347 100.216H62.9523C64.0623 100.216 64.962 99.3504 64.962 98.2832C64.962 97.2156 64.0623 96.3507 62.9523 96.3507Z",
    fill: "url(#paint5_linear_1582_533)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.993 108.499H35.3958C33.8105 108.499 32.5253 109.935 32.5253 111.706V121.33C32.5253 123.101 33.8105 124.537 35.3958 124.537H132.993C134.578 124.537 135.863 123.101 135.863 121.33V111.706C135.863 109.935 134.578 108.499 132.993 108.499Z",
    fill: "url(#paint6_linear_1582_533)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.9545,
    y: 38.2877,
    width: 114.202,
    height: 91.5332,
    rx: 5.93651,
    stroke: "#F5F4FB",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.659 89.5545C159.43 86.8939 159.992 84.1872 160.394 81.8449L160.439 81.582C160.769 79.667 161.012 78.2589 160.595 76.788C160.246 75.5598 159.434 74.292 158.455 73.4476C157.281 72.4359 155.775 72.0005 153.708 71.403L142.553 68.1703C140.613 67.6067 139.194 67.1947 137.706 67.3961C136.479 67.5621 135.114 68.1641 134.179 68.9511C133.044 69.9058 132.485 71.1004 131.728 72.7169L131.63 72.9271C130.563 75.2008 129.419 77.9644 128.586 80.8394C127.753 83.7144 127.242 86.6614 126.927 89.1531L126.898 89.3833C126.674 91.1541 126.508 92.4628 126.956 93.876C127.325 95.0411 128.157 96.2798 129.105 97.0757C130.255 98.0419 131.674 98.4521 133.615 99.0133L144.77 102.246C146.836 102.846 148.342 103.284 149.874 103.056C151.153 102.866 152.518 102.229 153.469 101.378C154.608 100.358 155.156 99.038 155.901 97.2434L156.003 96.9971C156.916 94.8028 157.888 92.215 158.659 89.5545ZM140.311 76.745C139.478 76.5035 138.612 76.9675 138.376 77.7813C138.14 78.5952 138.624 79.4507 139.457 79.6921L150.086 82.7724C150.92 83.0139 151.786 82.5498 152.022 81.736C152.258 80.9222 151.774 80.0667 150.941 79.8252L140.311 76.745ZM136.731 83.4557C136.967 82.6419 137.834 82.1779 138.667 82.4192L149.296 85.4995C150.129 85.741 150.613 86.5964 150.378 87.4103C150.142 88.2242 149.275 88.6881 148.442 88.4468L137.813 85.3664C136.98 85.1249 136.495 84.2695 136.731 83.4557ZM137.023 88.0923C136.19 87.8508 135.323 88.3148 135.087 89.1287C134.851 89.9425 135.335 90.7981 136.169 91.0394L141.483 92.5797C142.316 92.821 143.183 92.357 143.419 91.5432C143.655 90.7294 143.17 89.8739 142.337 89.6324L137.023 88.0923Z",
    fill: "#C1C2E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1582_533",
    x: 11.4465,
    y: 26.6568,
    width: 145.218,
    height: 122.551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.87698
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.75396
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.786354 0 0 0 0 0.807996 0 0 0 0 0.863646 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1582_533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.93651
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.419608 0 0 0 0 0.47451 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1582_533",
    result: "effect2_dropShadow_1582_533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1582_533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1582_533",
    x1: 84.0556,
    y1: 38.2877,
    x2: 84.0556,
    y2: 129.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateExpertise);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-state-expertise.a24648b0eea6ef753a94861dabe6f485.svg";